module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-4-photo-3-966f57d64048fb76744b1edfb561930c.webp";